import { useCallback, useMemo, useState } from "react"

export const useWorkingQueue = () => {
  const [workingQueue, setWorkingQueue] = useState<string[]>([])

  const isBusy = useMemo(() => !!workingQueue.length, [workingQueue])

  const addToQueue = useCallback((key: string) => {
    if (!key) return
    setWorkingQueue((prev) => (prev.includes(key) ? prev : [...prev, key]))
  }, [])

  const removeFromQueue = useCallback((key: string) => {
    setWorkingQueue((prev) => {
      const idx = prev.indexOf(key)
      if (idx === -1) return prev
      const newQueue = [...prev]
      newQueue.splice(idx, 1)
      return newQueue
    })
  }, [])

  return {
    isBusy,
    addToQueue,
    removeFromQueue
  }
}
